export const property = {
  gamefi: "趣投账户",
  mc_official_verify_unofficial: "非官方认证渠道",
  mc_official_verify_official: "官方",
  mc_official_verify_fotter_tip_1:
    "关于防范假冒Biking官方工作人员进行网络/电话诈骗的风险提示",
  mc_official_verify_fotter_tip_2:
    "关于警惕不法分子冒充、滥用“Biking”名义诈骗的严正声明及风险提示",
  mc_official_verify_modal_tip_1:"您查询的 【{query}】 经确认为Biking官方渠道",
  mc_official_verify_modal_tip_3: "请核实您输入的信息和格式是否正确：",
  mc_official_verify_modal_tip_4: "手机号码：xx-xxxxxxxxx",
  mc_official_verify_modal_type_email: "邮箱",
  mc_official_verify_modal_type_domain: "网址",
  mc_official_verify_modal_type_channel: "渠道",
  mc_official_verify_input_placeholder: "请您输入正确的信息和格式进行验证",
  mc_official_verify_head_title: "Biking交易所官方验证通道 | Biking交易所",
  mc_official_verify_head_description: "Biking交易所官方验证通道",
  mc_official_verify_title: "官方验证通道",
  mc_official_verify_discription_new:"为避免釣魚及网络诈骗给您带来资产损失，您可在此页面验证网址、邮箱地址、电话号码，或推特、电报等社交账号是否为Biking官方认证渠道。",
  mc_official_verify_fotter_tip_3:"Biking用户必读：预防诈骗手册，警惕诈骗手段升级！",
  mc_unofficial_verify_modal_tip_1:"您查询的 【{query}】 不是Biking官方渠道",
  mc_official_verify_discription:"为防止不法分子借用Biking全球站名义进行诈骗，您可通过此页面确认联系您的电话、微信等是否为Biking官方渠道",
  mc_official_head_title1: "验证 Biking 官方渠道、新闻和出版物",
  mc_official_head_keywords1: "Biking核实，Biking新闻，Biking官方账户",
  mc_official_head_description1:"确保Biking渠道的真实性。使用我们的官方验证工具来确认与 Biking 相关的频道、新闻和出版物的合法性。",
  mc_official_verify_verified_title: "官方认证渠道",
  mc_official_verify_modal_tip_5:"Telegram/X/Facebook/Youtube：@xxxxx（有@符号）",
  mc_official_verify_modal_tip_6: "TikTok/Instagram：xxxx（无@符号）",
  mc_official_verify_modal_tip_7: "Discord：xxxx#xxxx（无@符号）",
  mc_official_verify_modal_tip_8:"Linkedin/Telegram群/Medium/Reddit：https://xxxxx（网站链接）",
  mc_official_verify_modal_tip_9: "若您对信息格式有疑问，请随时联系在线客服。",
  mc_official_verify_modal_tip_10: "*请不要将您的账户信息与密码透露给任何人。",
  mc_official_verify_modal_tip_11:"*谨防诈骗，谨慎操作。",
  tagtip: "若充币平台未要求填写Comment，此项可留空",
  tagtip1: "Tag 是用于识别特定账户或用户的独特代码，能够确保资金发送给正确的收款人。",
  tagtip2: "其他交易平台或钱包可能会将 Tag 称为数字ID、Tag、Memo、Note、Remark、备注等。",
  tag: "请输入Comment",
  qbcbcg: "请同时复制 TON 地址及 comment，以确保成功充币",
  qsrzqje: "请输入正确金额",
  games: "游戏账户",
  cbxz: "Ethereum(ERC20)充币须知",
  tbxz: "Ethereum(ERC20)提币须知",
  ctbzysx: "请注意，每次FUFU官方智能合约转账都会收取额外的2%费用。",
  dzcw: "地址错误",
  czqkqrs: "充值区块确认数",
  mc: "名称",
  cjsj: "创建时间",
  lx: "类型",
  sl: "数量",
  cwjl: "财务记录",

  ylzh: "盈利",
  ddtx: "等待提现",
  txcg: "提现成功",
  yhcx: "用户撤销",
  qbcbjl: "全部充币记录",

  zczl: "资产总览",
  zjzh: "资金账户",
  mbzh: "买币账户",
  xhzh: "现货账户",
  hyzh: "合约账户",
  lczh: "理财账户",
  gdzh: "跟单账户",
  giftzh: "赠金账户",
  bwzh: "币王卡",
  mozh: "模拟账户",
  mnhy: "模拟合约",
  sxffy: "系统返佣",
  kt: "空投",
  xtkc: "系統扣除",
  zcfb: "资产分布",
  zcdt: "资产动态",
  zh: "账户",
  zc: "资产",
  czjl: "充值记录",
  txls: "提现历史",
  hzjl: "划转记录",
  mmjl: "买卖记录",
  cb: "充币",
  tx: "提现",
  hz: "划转",
  mb: "买币",
  jy: "交易",
  zwsj: "暂无数据",
  ckqb: "查看全部",

  // table
  bz: "币种",
  qc: "全称",
  zhze: "账户总额",
  syzc: "剩余资产",
  djzc: "冻结资产",
  cz: "操作",
  sl: "数量",
  cbdz: "充币地址",
  sj: "时间",
  zt: "状态",
  ms: "描述",
  hzfx: "划转方向",
  hzse: "划转数额",
  txdz: "提现地址",
  sxf: "手续费",
  ddh: "订单号",
  zj: "总价",
  dj: "单价",
  jysl: "交易数量",
  jydx: "交易对象",
  zhqy: "账户权益",
  zhqytips: "账户权益=可用保证金+仓位保证金",
  kybzj: "可用保证金",
  kybzjtips: "可用来开仓和划转出去的保证金",
  cwbzj: "仓位保证金",
  cwbzjtips: "用于维持现有仓位的保证金",

  // search
  srbz: "请输入对应币种",
  ycxzc: "隐藏小资产",
  sy: "所有",
  qb: "全部",
  qx: "全选",
  zhi: "至",
  ksrq: "开始日期",
  jsrq: "结束日期",
  cx: "查询",
  dc: "导出",
  zjqt: "最近7天",
  zjygy: "最近一个月",
  qbsj: "全部时间",
  usdt: "USDT",
  ddlx: "订单类型",
  gm: "购买",
  cs: "出售",

  // recharge
  czxq: "充值详情",
  usdtcbjl: "{coinName}充币记录",
  cbsl: "充币数量",
  cbzt: "充币状态",
  crdbz: "请选择您需要充入的币种",
  tqdbz: "请选择您需要提取的币种",
  rmbz: "热门币种",
  qxz: "请选择",
  cbwl: "充币网络",
  cbtips: "请确保您已选择与提币平台一致的网络进行充币，否则将造成资产损失。",
  txfs: "提现方式",
  lstx: "链上提现",
  xyb: "下一步",
  yxzdq: "已选择当前",
  dbz: "的币种",
  cxxz: "重新选择",
  dzkbz: "地址库地址不足，请联系管理员",
  qxzcrdbz: "请先选择充入的币种",
  qxzcbwl: "请选择充币网络",
  qxztqdbz: "请先选择提取的币种",
  cr: "充入",
  tq: "提取",
  cbxq: "充币详情",
  txxq: "提现详情",
  usdttxjl: "{coinName}提现记录",
  qbtxjl: "全部提现记录",
  zyxx: "重要信息：您只可发送{coinName}至此地址，若发送其他数字货币，您将会失去这笔资金。",
  jzjcr: "将资金充入",
  smewm: "扫描二维码或复制下列信息到发送平台",
  xcdzcz: "向此地址充值非此类型币种将导致您的资产无法找回",
  xcdzczss: "充入XRP 时请务必复制 tag，否则将会造成资金损失",
  znhycz: "目前不支持智能合约充值、打包充值、区块奖励充值",
  usdtcbdz: "{coinName}充币地址",
  fzdz: "复制地址",
  usdtdz: "{coinName}地址",
  zxcbe: "最小充币额",
  zytx2:
    "重要信息：请确保接受平台支持您所选择的 {coinName} 网络，否则您将丢失此资金。",
  kytxwl: "{coinName} 可用的提现网络",
  xzwl: "选择网络",
  dzym: "{coinName} 地址",
  srdz: "输入地址或从地址薄内选择",
  jymm: "交易密码",
  qsrjymm: "请输入交易密码",
  zxtbe: "最小提币额：{minAmount}",
  ky: "可用：",
  zhztbxe: "账户总提币限额",
  gjxyddj:
    "根据您的验证等级，您在 24 小时内只能提币有限额度。该限额会将USD转换为您选择的数字货币计算。",
  scbdjd:
    "由于币价波动较大，该币种的手续费为浮动手续费，根据前 24 小时平均币价，收取折合 0.2-0.2 USDT 的手续费增加手续费提升到账速度",
  yqdz: "预期到账",
  yqdzwf: "预期到账不能为负数",
  sfrz: "身份认证",
  ggyzm: "Google身份验证码",
  dxyzm: "短信验证码",
  yxyzm: "邮箱验证码",
  qsryzm: "请输入验证码",
  fsyzm: "发送验证码",
  cxfs: "重新发送",
  tj: "提交",
  qxztxwl: "请选择提现网络",
  qsrdz: "请输入地址",


  qxzdz: "请选择地址",
  qxzyzfs: "请选择一种身份认证方式",
  qsrtqsl: "请输入提取的数量",
  qwcyz: "请完成验证",
  qqrbdsj: "请先确认是否绑定手机",
  qqrbdyx: "请先确认是否绑定邮箱",
  fzcg: "复制成功！",
  tbcg: "提币成功",
  usdttxdz: "{coinName}提现地址",
  lmc: "链名称:",
  qtj: "*请添加",
  dz: "地址",
  fei: "非",
  zjds: "地址可能会导致资产丢失",
  yzfs: "验证方式",
  yzm: "验证码",
  remark: "备注",
  qsrremark: "请输入备注",
  tjdzcg: "添加地址成功",
  qxxzyzfs: "请先选择验证方式",
  qsrtxdz: "请输入提现地址",

  
  stop: "暂停",

  // status
  qr0: "0确认",
  qr1: "1确认",
  dqr: "待确认",
  czcg: "充值成功",
  hzz: "划转中",
  ywc: "已完成",
  sb: "失败",
  zzcl: "正在处理",
  ddsh: "等待审核",
  txcg: "提现成功",
  cxcg: "撤销成功",
  ddtx: "等待提现",
  txsb: "提现失败",
  slsb: "上链失败",
  dfk: "待付款",
  yfk: "已付款",
  yqx: "已取消",
  ssz: "申诉中",
  gdfrhz: "跟单分润划转",
  hyzh_to_gdzh: "合约账户 - 跟单账户",
  gdzh_to_hyzh: "跟单账户 - 合约账户",
  ddcl: "等待处理",
  cg: "成功",

  // dialog
  zchz: "资产划转",
  ljhz: "立即划转",
  cong: "从",
  dao: "到",
  qtzh: "其他账户",
  qxzbz: "请选择币种",
  qsrsl: "请输入数量",
  khz: "可划转:",
  ye: "余额:",
  hzcg: "划转成功",

  // h5
  zcgl: '资产概览',
  xrzx: '新人专享',
  zzc: '总资产',
  jryk: '今日盈亏',
  zgjz: '最高价值3200 USDT新人礼包等您来拿',
  zhrj: '为您的账户入金',
  xzrjfs: '入金后即可购买数字货币，您可依照实际情况选择入金方式',
  czszhb: '充值数字货币',
  yyydszhb: '将您在其他平台已拥有的数字货币充值到Biking账户中。',
  czfb: '充值法币',
  czzhz: '将您已拥有的法定货币充值到Biking账户中，支持银行卡，转账等多种支付方式',
  maibi: '买币',
  tgdsfmb: '通过银行卡、P2P、第三方等方式购买数字货币',
  yqyl: '邀请有礼',
  yqfy: '邀请好友享20%返佣',
  cxzzn: '初学者指南',
  czzh: '创建一个Biking账户',
  hdxrj: '获得100USDT 新人奖金',
  ck: '存款',
  tzndzh: '投资您的账户，开始您的旅程，支持多种付款方式',
  wcsfrz: '完成身份认证（KYC）',
  hgzh: '完成身份认证（KYC）并成为合规账户',
  ksjy: '开始交易',
  tsgd: '出售、购买或复制交易，探索更多',
  ksndlc: '开始您的旅程',
  kjydjmhb: '可交易的加密货币',
  jmhb: '加密货币总价值是12284.85亿美金',
  zengjin: "赠金",
  lc: "理财",
  mb: "买币",
  lsjl: "历史记录",
  zclb: "资产列表",
  shaixuan: "筛选",
  批量导入地址:'批量导入地址',
  请输入地址或名称:'请输入地址或名称',
  地址名称:'地址名称',
  上传普通地址:'上传普通地址',
  上传成功:'上传成功',
  一次只能上传一个文件哦:'一次只能上传一个文件哦',
  文件大小不得超过10M:'文件大小不得超过10M',
  请先选择要上传的文件:'请先选择要上传的文件',
  只能上传后缀是:'只能上传后缀是.xlsx或者.xls的文件或者.csv的文件',
  将文件拖到此处:'将文件拖到此处，或',
  点击上传:'点击上传',
  最大1MB:'CSV、XLS、XLSX文件 最大1MB',
  编号:'编号',
  所属网络:'所属网络',
  地址簿:'地址簿',
  新增地址:'新增地址',
  提币地址一次不超过100个:'提币地址一次不超过100个',
  添加地址:'添加地址',
  保存地址:'保存地址',
  下载模板:'下载模板',
  批量提现:'批量提现',
  请输入Memo:'请输入Memo',
  请输入地址名称:'请输入地址名称',
  您可以通过:'您可以通过CSV、XLS或XLSX格式文件（最大1MB）上传最多20个普通地址，每列标题必须与模版一致，否则将会导致上传失败。'

}


// WEBPACK FOOTER //
// ./src/i18n/lang/property/zh.js